module.exports = __webpack_public_path__ + "static/media/case-1.e53e4ac7.png";